<template><div class="settings main flex">
  <sticky-bar
      search="fleet or user name"
      v-model="filter"
      @back="$router.push('/s')"
      @keydown.esc="filter = ''"
      :loading="!!owner.fleetIdsLoading || !!owner.usersLoading">
    User Access Control
  </sticky-bar>
  <div class="flex-fill padded scroll">
    <ul>
      <li v-if="owner.fleetIds">
        Manage by fleet. Select a fleet:
        <i v-if="filteredFleetIds.length === 0">No results</i>
        <div v-else class="link-list">
          <router-link
              v-for="fid in filteredFleetIds"
              :key="`f-${fid}`"
              v-html="fleets[fid].name"
              :to="`/s/uac/f/${fid}`"
            />
        </div>
      </li>
      <li v-else-if="!permissions || owner.fleetIdsLoading">Loading <Loading /></li>
      <li v-else>An error ocurred. <button @click="refreshOwnerFleetIds">Try Again</button></li>
      <li v-if="owner.users">
        Manage by user. Select a user:
        <i v-if="filteredUsers.length === 0">No results</i>
        <div v-else class="link-list">
          <router-link
              v-for="u in filteredUsers"
              :key="`u-${u.email}`"
              :to="`/s/uac/u/${u.email}`"
              :class="{'needs-invitation':u.needsInvitation}">
            {{ u.email }}
            <template v-if="u.firstName">({{ u.firstName }} {{ u.lastName }})</template>
            <i v-else-if="u.needsInvitation">(Needs invitation)</i>
            <i v-else>(Invited)</i>
          </router-link>
        </div>
      </li>
      <li v-else-if="!permissions || owner.usersLoading">Loading <Loading /></li>
      <li v-else>An error occurred. <button @click="refreshOwnerUsers">Try Again</button></li>
    </ul>
  </div>
</div></template>
<script>
import api from '../../../api'
import Loading from '../../Loading'
import StickyBar from '../../StickyBar'

import { mapActions, mapState } from 'vuex'

export default {
  name: 'settings',
  components: { Loading, StickyBar },
  data() {
    return {
      error: null,
      filter: '',
    }
  },
  computed: {
    fleets() { return this.$store.getters.fleets },
    owner() { return this.$store.state.owner },
    filteredFleetIds() {
      if (!this.filter) return this.owner.fleetIds
      let filter = this.filter.toLowerCase()
      return this.owner.fleetIds.filter(fid => this.fleets[fid].name.toLowerCase().indexOf(filter) >= 0)
    },
    filteredUsers() {
      if (!this.filter) return this.owner.sortedUsers
      let filter = this.filter.toLowerCase()
      return this.owner.sortedUsers.filter(u => (
        u.email.toLowerCase().indexOf(filter) >= 0
        || (u.firstName && u.firstName.toLowerCase().indexOf(filter) >= 0)
        || (u.lastName && u.lastName.toLowerCase().indexOf(filter) >= 0)))
    },
    ...mapState(['permissions']),
  },
  methods: {
    async refresh() {
      this.error = null
    },
    ...mapActions(['refreshOwnerFleetIds', 'refreshOwnerUsers']),
  },
  created() {
    if (this.permissions) {
      this.refreshOwnerFleetIds()
      this.refreshOwnerUsers()
    }
  },
  watch: {
    permissions(nv, ov) {
      if (nv && !ov) {
        this.refreshOwnerFleetIds()
        this.refreshOwnerUsers()
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.link-list {
  padding: 5px 0;
  a {
    display: inline-block;
    margin: 0 5px 5px 0;
    text-decoration: none;
    border-radius: 5px;
    background: #ccc;
    padding: 5px 10px;
    &.needs-invitation {
      background: #dd0;
    }
  }
}
</style>
